import Tooltip from "components/Tooltip";
import PropTypes from 'prop-types';
const Input_ = (props) => {

    return (
        <div className={`${props.className} relative `}>
            {(props.label || props.tooltip) &&
                <div className="flex items-center mb-2">
                    <label htmlFor={props.id} className="relative font-medium text-gray-900 dark:text-gray-300 capitalize text-sm  leading-tight tracking-normal flex ">
                        {props.label} {props.required && <span className="text-red-500 ms-1">*</span>}
                    </label>
                    {props?.tooltip && <Tooltip className="ms-2">
                        <p className=" text-sm leading-4 text-gray-600 ">{props.tooltip}</p>
                    </Tooltip>}
                </div>
            }
            <div className="flex flex-nowrap items-center ">
                {(!props.prefix && !props.suffix) && <input
                    id={props.id}
                    {...props}
                    {...props.register}
                    className="border border-gray-300  text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full p-2  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />}

                {props.prefix &&
                    <div className="relative w-full">
                        <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                            {props.prefix}
                        </div>
                        <input
                            id={props.id}
                            {...props}
                            {...props.register}
                            className=" border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        />
                    </div>}


                {props.suffix &&
                    <div className="relative w-full">
                        <div className="flex absolute inset-y-0 right-0 items-center px-2  cursor-pointer">
                            {props.suffix}
                        </div>
                        <input
                            id={props.id}
                            {...props}
                            {...props.register}
                            className=" border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full pe-10 p-2  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        />
                    </div>}
            </div>

            {!!props.error &&
                <div className="text-red-500 text-xs mt-1">
                    {props?.error?.message}
                </div>
            }
        </div >

    );
}

Input_.propTypes = {
  className: PropTypes.string,
  label: PropTypes.node,
  tooltip: PropTypes.node,
  id: PropTypes.string,
  required: PropTypes.bool,
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  register: PropTypes.object,
  error: PropTypes.object,
};

export default Input_;